import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, change } from "redux-form";
import { setShippingInformation, inputValidation, clearValidation, estimateShippingMethod, fetchShippingMethod, fetchCustomShippingMethods, setSelectedShippingAddress, addNewShippingAddress, updateCustomer, setLoader } from "../actions";


class CheckoutShipping extends React.Component {
  constructor(props){
    super(props)

    this.addressInput = React.createRef()

    this.state = {
      showAddAllAddresses: false,
      show_address_fields: false, 
      customer: null,
      shippingAddressRadios: null,
      savedShippingAddress: false,
      backup_selected_shipping_address: null,
      regions: [
        {
          "id": "569",
          "code": "ACT",
          "name": "Australian Capital Territory"
        }, 
        {
          "id": "570",
          "code": "NSW",
          "name": "New South Wales"
        },
        {
          "id": "576",
          "code": "NT",
          "name": "Northern Territory"
        },
        {
          "id": "572",
          "code": "QLD",
          "name": "Queensland"
        },
        {
          "id": "573",
          "code": "SA",
          "name": "South Australia"
        },
        {
          "id": "574",
          "code": "TAS",
          "name": "Tasmania"
        },
        {
          "id": "571",
          "code": "VIC",
          "name": "Victoria"
        },
        {
          "id": "575",
          "code": "WA",
          "name": "Western Australia"
        }
      ]
    }
  }

  setShippingAddressRadios = (index = 'last') => {
    const addresses = this.props.shipping_addresses?.addresses || [];
    const shipping_address_radios = addresses.map(v => {
      return false;
    });

    if (this.state.savedShippingAddress && this.props.selected_shipping_address) {
      if (index === 'last') {
        const actual_index = addresses.findIndex(v => v.id === this.props.selected_shipping_address?.id);
        if (actual_index >= 0) {
          shipping_address_radios[actual_index] = true;
        }
      } else {
        shipping_address_radios[index] = true;
      }
    } else {
      if (index === 'last') {
        shipping_address_radios[shipping_address_radios.length] = true;
      } else {
        shipping_address_radios[shipping_address_radios.length] = false;
        shipping_address_radios[index] = true;
      }
    }

    this.setState({ shippingAddressRadios: shipping_address_radios });
  }

  componentDidMount = () => {
    // Load shipping addresses from localStorage if not in Redux
    const storedAddresses = JSON.parse(localStorage.getItem("shippingAddresses") || "[]");
    const storedSelectedAddress = JSON.parse(localStorage.getItem("selectedShippingAddress"));

    // If we have stored addresses but none in Redux, load them
    if (storedAddresses.length > 0 && (!this.props.shipping_addresses?.addresses || this.props.shipping_addresses.addresses.length === 0)) {
      storedAddresses.forEach(addr => {
        this.props.addNewShippingAddress(addr);
      });
    }

    // If we have a stored selected address but none in Redux, set it
    if (storedSelectedAddress && !this.props.selected_shipping_address) {
      this.props.setSelectedShippingAddress(storedSelectedAddress.id || storedSelectedAddress.region_id, storedAddresses.length > 0 ? storedAddresses : [storedSelectedAddress]);
      // Also set saved state so the default address shows properly
      this.setState({ savedShippingAddress: true });
    } else if (this.props.selected_shipping_address) {
      // If there's already a selected address in Redux, mark as saved
      this.setState({ savedShippingAddress: true });
    }

    // Pre-fill form fields from localStorage
    const mobile = localStorage.mobile || '';
    const firstName = localStorage.first_name || '';
    const lastName = localStorage.last_name || '';
    if (mobile) {
      this.props.change("mobile", mobile);
    }
    if (firstName || lastName) {
      this.props.change("fullname", `${firstName} ${lastName}`.trim());
    }
  }

  componentDidUpdate = () => { 
    if(this.state.showAddAllAddresses) {
      var autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('google-places-input'));
      autocomplete.addListener('place_changed', () => {
          var place = autocomplete.getPlace();
          console.log(place)

          if(place.address_components != undefined) {

            const address = {
              street_address: "", 
              suburb: "",
              state: "",
              country: "",
              postcode: ""
            }

            // set country
            place.address_components.forEach(function (value) {
                if (value.types.includes("country")) {
                    address.country = value.short_name
                }
            });

            // set street address
            var street_address = "";
            place.address_components.forEach(function (value) {
                if (value.types.includes("street_number")) {
                    street_address += value.long_name
                }
            });
            street_address += " ";
            place.address_components.forEach(function (value) {
                if (value.types.includes("route")) {
                    street_address += value.long_name
                }
            });
            address.street_address = street_address

            // set city/suburb - check multiple possible types with priority
            place.address_components.forEach(function (value) {
                if (value.types.includes("administrative_area_level_2") && !address.suburb) {
                  address.suburb = value.long_name;
                }
            });
            place.address_components.forEach(function (value) {
                if (value.types.includes("sublocality") || value.types.includes("sublocality_level_1")) {
                  address.suburb = value.long_name;
                }
            });
            place.address_components.forEach(function (value) {
                if (value.types.includes("postal_town")) {
                  address.suburb = value.long_name;
                }
            });
            place.address_components.forEach(function (value) {
                if (value.types.includes("locality")) {
                  address.suburb = value.long_name;
                }
            });

            // set state
            place.address_components.forEach(function (value) {
                if (value.types.includes("administrative_area_level_1")) {
                    address.state = value.long_name
                }
            });

            place.address_components.forEach(function (value) {
                if (value.types.includes("postal_code")) {
                    address.postcode = value.long_name
                } 
            });

            let customer = {}
            if(this.state.customer) {
              customer = this.state.customer;
              if (this.state.customer.address) {
                delete customer.address;
              }
            }
            customer.address = address;
            this.setState({ customer: customer })
            //       address: {
            //         street_address: "10 Bonita Court", 
            //         suburb: "Mudgeeraba",
            //         state: "QLD",
            //         country: "Australia",
            //         postcode: "4213"
            //       } 
            let region_id = null;
            this.state.regions.forEach((v) => {
              // Match by full name or short code (Google Places may return either)
              if(v.name === address.state || v.code === address.state) {
                region_id = v.id
              }
            })
            const country_id = "AU"
            this.props.change('address', place.formatted_address);
            this.props.change('street_address', address.street_address);
            this.props.change('suburb', address.suburb);
            this.props.change('state', region_id);
            this.props.change('country', country_id);
            this.props.change('postcode', address.postcode);

            // Show address fields if region not found so user can fix it
            if (!region_id) {
              console.log('Region not found for:', address.state);
              this.setState({ show_address_fields: true });
            }
            
            this.props.clearValidation() 
        } else { 
            // show inputs
        }
      })
    }
  }

  handleSubmit = (formValues) => {
    console.log(formValues)

    const country_id = "AU"
    this.props.change('country', country_id); 

    let input_validation = {}
    let show_address_fields = false;

    // mobile
    if(!formValues.mobile || formValues.mobile.trim().length === 0) {
      input_validation.mobile = ["Please enter a valid mobile"]
    }
    // fullname
    if(!formValues.fullname || formValues.fullname.trim().length === 0 || formValues.fullname.trim().split(' ').length < 2) { 
      input_validation.fullname = ["Please enter your full name"]
    }
    // street_address
    if(!formValues.street_address || formValues.street_address.trim().length === 0) {
      input_validation.street_address = ["Missing street address"]
      show_address_fields = true;
    }
    // suburb
    if(!formValues.suburb || formValues.suburb.trim().length === 0) {
      input_validation.suburb = ["Missing suburb"]
      show_address_fields = true;
    }
    // state
    const stateValue = formValues.state ? String(formValues.state).trim() : '';
    if(!stateValue || stateValue.length === 0 || stateValue === "Enter State") {
      input_validation.state = ["Missing state"]
      show_address_fields = true;
    }
    // country
    if(!formValues.country || formValues.country.trim().length === 0) {
      input_validation.country = ["Missing country"]
      show_address_fields = true;
    }
    // postcode
    if(!formValues.postcode || formValues.postcode.trim().length === 0) {
      input_validation.postcode = ["Missing postcode"]
      show_address_fields = true;
    }
    console.log('input_validation', input_validation)

    if(Object.keys(input_validation).length > 0) {
      if(show_address_fields) { 
        this.setState({ show_address_fields: true })
      }      
      this.props.inputValidation(input_validation)
      if(this.addressInput) {
        this.addressInput.focus()
      }
    } else {
      console.log('VALID!!!') 
      this.props.clearValidation()
      // setup data for ajax

      const names = formValues.fullname.trim().split(' ')
      const firstname = names[0];
      names.splice(0, 1)
      const lastname = names.join(' ')  

      const region = this.state.regions.filter(v => {
        return v.id == formValues.state
      })
      console.log('region', region)

      let region_data = {}
      if(region.length > 0) {
        region_data = region[0]
      } else {
        console.log('Error getting region')
        return
      }

      console.log('region_data', region_data)

      let esm_data = {  
        address: {
          city: formValues.suburb,
          company: "",
          country_id: formValues.country,
          firstname: firstname,
          lastname: lastname,
          postcode: formValues.postcode,
          region: region_data.name,
          region_code: region_data.code,
          region_id: region_data.id,
          saveInAddressBook: 0,
          street: [
            formValues.street_address
          ],
          telephone: formValues.mobile
        }
      }
      
      const new_shipping_address_data = {
        region: {
          region_code: region_data.code,
          region: region_data.name,
          region_id: region_data.id 
        },
        region_id: region_data.id,
        country_id: formValues.country,
        street: [
          formValues.street_address
        ],
        telephone: formValues.mobile,
        postcode: formValues.postcode,
        city: formValues.suburb,
        firstname: firstname,
        lastname: lastname
      }

      // this.props.addNewShippingAddress(new_shipping_address_data)
      this.props.setLoader(true, "Updating Shipping...")
      this.props.estimateShippingMethod(esm_data, () => {
        console.log('shipping method updated')

        // Build shipping address object
        const shippingAddress = {
          city: formValues.suburb,
          company: "",
          countryId: formValues.country,
          country_id: formValues.country,
          firstname: firstname,
          lastname: lastname,
          postcode: formValues.postcode,
          region: region_data.name,
          regionCode: region_data.code,
          region_code: region_data.code,
          regionId: region_data.id,
          saveInAddressBook: 0,
          street: [formValues.street_address],
          telephone: formValues.mobile
        };

        // Use shipping address as billing address (common practice)
        const email = localStorage.email || this.props.auth?.email || '';
        const billingAddress = {
          ...shippingAddress,
          email: email,
        };

        let data = {
          addressInformation: {
            billing_address: billingAddress,
            extension_attributes: {},
            shipping_address: shippingAddress,
            shipping_carrier_code: this.props.shipping_method?.carrier_code || 'flatrate',
            shipping_method_code: this.props.shipping_method?.method_code || 'flatrate'
          }
        };

        // Save shipping address to localStorage
        localStorage.setItem("selectedShippingAddress", JSON.stringify(shippingAddress));
        localStorage.setItem("billingAddress", JSON.stringify(billingAddress));

        // Add to shipping addresses list
        this.props.addNewShippingAddress(new_shipping_address_data);

        // Update customer profile with new address
        const mobile = localStorage.mobile || this.props.auth?.mobile || '';

        // Give the new address a temporary ID
        const addressWithId = {
          ...new_shipping_address_data,
          id: `new_${Date.now()}`,
        };

        this.props.updateCustomer({
          firstname: firstname,
          lastname: lastname,
          email: email,
          addresses: [addressWithId]
        }, () => {
          this.setState({ savedShippingAddress: true });
          this.props.setShippingInformation(data, () => {
            this.props.setLoader(false, null);
            // Set the selected shipping address directly using dispatch
            this.props.setSelectedShippingAddress(addressWithId.id, [addressWithId]);
            this.setState({ backup_selected_shipping_address: addressWithId });
            this.setShippingAddressRadios();
          });
        });
      });
    }
  }

  selectShippingAddress = (shipping_address_id) => {
    this.props.clearValidation();
    this.props.setLoader(true, "Updating Shipping...");

    // Get seller ID for shipping rules
    const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
    const sellerId = cartItems.length > 0 ? cartItems[0].seller_id : null;

    this.props.fetchCustomShippingMethods(sellerId, () => {
      console.log('got new shipping method');

      let selected_shipping_address = this.props.shipping_addresses.addresses.filter(v => {
        return shipping_address_id == v.id;
      });

      if (selected_shipping_address.length > 0) {
        selected_shipping_address = selected_shipping_address[0];
      } else {
        console.log('error, cant get shipping address based on id');
        this.props.setLoader(false, null);
        return;
      }

      this.props.setSelectedShippingAddress(shipping_address_id, this.props.shipping_addresses.addresses);

      const backup_selected_shipping_address = this.props.shipping_addresses.addresses.find(v => v.id === shipping_address_id);
      this.setState({ backup_selected_shipping_address: backup_selected_shipping_address });

      // Build shipping address object
      const shippingAddress = {
        city: selected_shipping_address.city,
        company: "",
        countryId: selected_shipping_address.country_id,
        country_id: selected_shipping_address.country_id,
        firstname: selected_shipping_address.firstname,
        lastname: selected_shipping_address.lastname,
        postcode: selected_shipping_address.postcode,
        region: selected_shipping_address.region?.region || '',
        regionCode: selected_shipping_address.region?.region_code || '',
        region_code: selected_shipping_address.region?.region_code || '',
        regionId: selected_shipping_address.region?.region_id || '',
        saveInAddressBook: 0,
        street: selected_shipping_address.street,
        telephone: selected_shipping_address.telephone
      };

      // Use shipping address as billing address
      const email = localStorage.email || this.props.auth?.email || '';
      const billingAddress = {
        ...shippingAddress,
        email: email,
      };

      let data = {
        addressInformation: {
          billing_address: billingAddress,
          extension_attributes: {},
          shipping_address: shippingAddress,
          shipping_carrier_code: this.props.shipping_method?.carrier_code || 'flatrate',
          shipping_method_code: this.props.shipping_method?.method_code || 'flatrate'
        }
      };

      // Save to localStorage
      localStorage.setItem("selectedShippingAddress", JSON.stringify(shippingAddress));
      localStorage.setItem("billingAddress", JSON.stringify(billingAddress));

      this.props.setShippingInformation(data, () => {
        console.log('saved shipping information');
        this.props.setLoader(false, null);
        console.log('shipping updated');
      });
    });
  }

  renderRadio = ({ input, type, className, onClick, checked }) => { 
    return (
      <input {...input} type={type} className={className} onClick={onClick} checked={checked} /> 
    )
  }

  renderInput = ({ input, label, type, defaultValue, readonly, id, addressCallback }) => {
    return ( 
      <div>
        <input {...input} id={id} type={type} placeholder={label} onKeyPress={(e) => {
          if(e.key === "Enter") {
            e.preventDefault();
          }
        }} ref={addressCallback}/>
      </div>
    );
  };

  renderSelect = ({ input, isCountries, isRegions, defaultValue }) => {
    let options = null
    if(isCountries) {
      options = (
        <option key="AU" value="AU" defaultValue={defaultValue}>Australia</option>
      ) 
    } else if(isRegions) {
      options = [
        <option key="enter_state">Enter State</option>
      ]
      let region_options = []
      if(this.state) { 
        region_options = this.state.regions.map(region => {
          return (
            <option key={region.id} value={region.id}>
              {region.name}
            </option>
          );
        });
      }
      options = options.concat(region_options);
    }

    

    return (
      <div className="select-wrapper">
        <select {...input} defaultValue={defaultValue}>{options}</select>  
      </div>
    );
  };

  renderDefaultShippingAddress = () => {
    console.log('renderDefaultShippingAddress')
    let default_shipping_address = null
    console.log('this.props.selected_shipping_address', this.props.selected_shipping_address)
    if(this.props.selected_shipping_address) {
      const shipping_address = this.props.selected_shipping_address
      default_shipping_address = ( 
        <div id="default-shipping-address">
          <div>{shipping_address.firstname} {shipping_address.lastname}</div>
          <div style={{ marginTop: '3px'}}>{shipping_address.street[0]}, {shipping_address.city} {shipping_address.postcode}</div> 
        </div>
      )
    }
    return default_shipping_address
  }

  renderAddAllAddresses = () => {
    let mobileMessage = this.props.input_validation.mobile.map(message => 
      <div key={message} className="input-validation">{message}</div>);
    let fullnameMessage = this.props.input_validation.fullname.map(message => 
      <div key={message} className="input-validation">{message}</div>); 
    let addressMessage = this.props.input_validation.address.map(message => 
      <div key={message} className="input-validation">{message}</div>);
    let streetAddressMessage = this.props.input_validation.street_address.map(message => 
      <div key={message} className="input-validation">{message}</div>);
    let suburbMessage = this.props.input_validation.suburb.map(message => 
      <div key={message} className="input-validation">{message}</div>);
    let stateMessage = this.props.input_validation.state.map(message => 
      <div key={message} className="input-validation">{message}</div>);
    let countryMessage = this.props.input_validation.country.map(message => 
      <div key={message} className="input-validation">{message}</div>);
    let postcodeMessage = this.props.input_validation.postcode.map(message => 
      <div key={message} className="input-validation">{message}</div>);

    const all_shipping_addresses = this.props.shipping_addresses.addresses.map((v, i, a) => {
      return (
        <div key={v.id} className="shipping-address">
          <div className="shipping-address-left">
            <Field
              name="shipping_address"
              component={this.renderRadio} 
              type="radio"
              className="shipping-address-radio"
              onClick={() => {
                console.log('triggered '+v.id)
                this.setShippingAddressRadios(i)    
                this.selectShippingAddress(v.id)
              }}
              checked={this.state.shippingAddressRadios[i]}
            />
          </div>
          <div className="shipping-address-right">
            <div>{v.firstname} {v.lastname}</div>
            <div style={{ marginTop: '3px'}}>{v.street[0]}, {v.city} {v.postcode}</div> 
          </div>
        </div>
      )
    })

    return (
      <div id="all-shipping-addresses">
        <div>
          <form 
            className="form" 
            id="checkout-shipping-form"
            onSubmit={this.props.handleSubmit(this.handleSubmit)}  
          > 
            {all_shipping_addresses}
            {!this.state.savedShippingAddress && <div className="shipping-address">
              <div className="shipping-address-left">
                <Field
                  name="shipping_address"
                  component={this.renderRadio} 
                  type="radio"
                  className="shipping-address-radio-new"
                  checked={this.state.shippingAddressRadios[
                    this.state.shippingAddressRadios.length-1
                  ]}
                  onClick={() => {
                    this.setShippingAddressRadios()
                  }}
                />
              </div>
              <div className="shipping-address-right">
                <div id="checkout-shipping-form">
                  <div id="add-new-address-heading">Add New Address</div>
                  <div className="input-box">
                    <Field
                      name="fullname"
                      component={this.renderInput}
                      label="Fullname"
                      type="text"
                    />
                    {fullnameMessage}
                  </div>
                  <div className="input-box">
                    <Field
                      name="mobile"
                      component={this.renderInput}
                      label="Mobile"
                      type="text"
                      // readonly={true}
                    />
                    {mobileMessage}
                  </div>
                  <div className="input-box">
                    <Field
                      name="address"
                      component={this.renderInput}
                      label="Type Address..."
                      type="text"
                      id="google-places-input"
                      onKeyPress={e => {
                        console.log('in here7878')
                        if (e.key === 'Enter') e.preventDefault();
                      }} 
                      addressCallback={(input) => {
                        this.addressInput = input 
                      }}
                    />
                    {addressMessage}
                  </div>
                  {this.state.show_address_fields && <div>
                    <div className="input-box">
                      <Field
                        name="street_address"
                        component={this.renderInput}
                        label="Enter Street Address"
                        type="text"
                      />
                      {streetAddressMessage}
                    </div>
                    <div className="input-box">
                      <Field
                        name="suburb"
                        component={this.renderInput}
                        label="Enter Suburb"
                        type="text"
                      />
                      {suburbMessage}
                    </div>
                    <div className="input-box">
                      <Field
                        name="state"
                        component={this.renderSelect}
                        label="Enter State"
                        type="text"
                        isRegions={true} 
                        value="569"
                      />
                      {stateMessage}
                    </div>
                    <div className="input-box">
                      <Field
                        name="country"
                        component={this.renderSelect}
                        label="Enter Country"
                        type="text"
                        isCountries={true}
                        defaultValue="AU" 
                      />
                      {countryMessage}
                    </div>
                    <div className="input-box">
                      <Field
                        name="postcode"
                        component={this.renderInput}
                        label="Enter Postcode"
                        type="text"
                      />
                      {postcodeMessage}
                    </div>
                  </div>}
                  <button id="add-shipping-address-button" type="submit">Save Address</button>
                </div>
              </div>
            </div>}
          </form>
        </div>
      </div>
    )
  }

  render() {
    return ( 
        <div id="checkout-shipping">
          <div id="checkout-shipping-heading">Shipping Information</div>
          {!this.state.showAddAllAddresses && this.renderDefaultShippingAddress()}
          {this.state.showAddAllAddresses && this.renderAddAllAddresses()}
          {!this.state.showAddAllAddresses && <div className="shipping-add-update" onClick={() => {
            this.setState({ 
              showAddAllAddresses: true, 
              backup_selected_shipping_address: this.props.selected_shipping_address 
            }) 
            this.setShippingAddressRadios() 
            this.props.setSelectedShippingAddress(null, this.props.shipping_addresses.addresses)
          }}>Add New</div>}
          <div className="checkout-arrow" onClick={() => {
            if(!this.state.showAddAllAddresses) {
              this.setShippingAddressRadios() 
              this.setState({ backup_selected_shipping_address: this.props.selected_shipping_address }) 
              this.props.setSelectedShippingAddress(null, this.props.shipping_addresses.addresses)
            } else {
              this.props.setSelectedShippingAddress(
                this.state.backup_selected_shipping_address.id,
                this.props.shipping_addresses.addresses
              ) 
            }
            this.setState({ showAddAllAddresses: !this.state.showAddAllAddresses })
          }}></div>  
          
        </div>
    );
  }
}

const mapStateToProps = state => {
  return { 
    shipping_addresses: state.shipping_addresses,
    input_validation: state.input_validation,
    billing_address: state.billing_address.billing_address,
    shipping_method: state.shipping_method.shipping_method,
    cart: state.cart.cart,
    selected_shipping_address: state.selected_shipping_address.selected_shipping_address,
    auth: state.auth
  };
};

const checkoutShipping = reduxForm({ 
  form: "checkout-shipping"
})(CheckoutShipping); 

export default connect(
  mapStateToProps,
  { setShippingInformation, inputValidation, clearValidation, estimateShippingMethod, fetchShippingMethod, fetchCustomShippingMethods, setSelectedShippingAddress, addNewShippingAddress, updateCustomer, setLoader }
)(checkoutShipping);
